import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Dmca from "./pages/dmca.js";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Enroll from "./pages/Enroll.js";
import Signup from "./pages/Signup.js";
import Review from "./pages/Review.js";
import ThankPage from "./pages/ThankPage.js";
import OrderConfirmation from "./pages/OrderConfirmation.js";
import Signin from "./pages/Signin.js";
import JoinNow from "./pages/JoinNow.js";
import Checkout from "./pages/Checkout.js";
import Technology from "./pages/Technology";
import SpamPolicy from "./pages/Spampolicty.js";
import RiskWarning from "./pages/RiskWarning.js";
import RefundPolicy from "./pages/Refundpolicy.js";
import UserAgreement from "./pages/UserAgreement.js";
import EnrollmentKit from "./pages/EnrollmentKit.js";
import PrivacyPolicy from "./pages/PrivacyPolicy.js";
import ShoppingCart from "./pages/ShoppingCart.js";
import TermsAndCondition from "./pages/Termandcondition.js";
import { ToastContainer } from "react-toastify";
import "./App.css";
import SessionExpiredModal from "./components/SessionExpiredModal.js";
import PoliciesAndProcedures from "./pages/PoliciesProcedures.js";
import PoliciesProcedures from "./pages/PoliciesProcedures.js";
import TokenRefreshModal from "./components/token-refresh-modal.js";
import "react-toastify/dist/ReactToastify.css";
import AddOn from "./pages/AddOn.js";

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      {/* <SessionExpiredModal /> */}
      <Routes>
        <Route path="/:enrollerCode?" exact element={<Home />} />
        <Route path="/:enrollerCode?/about" element={<About />} />
        <Route path="/:enrollerCode?/pricing" element={<Pricing />} />
        <Route path="/:enrollerCode?/technology" element={<Technology />} />
        <Route path="/:enrollerCode?/contact-us" element={<Contact />} />
        <Route path="/JoinNow" element={<JoinNow />} />
        <Route path="/:enrollerCode/enroll" element={<Enroll />} />
        <Route path="/:enrollerCode/signup" element={<Signup />} />
        <Route
          path="/:enrollerCode?/enrollment-kit"
          element={<EnrollmentKit />}
        />
        <Route path="/:enrollerCode?/addOn" element={<AddOn />} />
        <Route path="/:enrollerCode?/review" element={<Review />} />
        <Route path="/thank-you/:orderId" element={<ThankPage />} />
        <Route
          path="/order-confirmation/:type/:orderId"
          element={<OrderConfirmation />}
        />
        <Route path="/signin" element={<Signin />} />
        <Route
          path="/:enrollerCode?/PoliciesProcedures"
          exact
          element={<PoliciesProcedures />}
        />
        <Route
          path="/:enrollerCode?/useragreement"
          exact
          element={<UserAgreement />}
        />
        <Route
          path="/:enrollerCode?/riskwarning"
          exact
          element={<RiskWarning />}
        />
        <Route path="/shopping-cart" element={<ShoppingCart />} />
        <Route
          path="/:enrollerCode?/refundpolicy"
          exact
          element={<RefundPolicy />}
        />
        <Route
          path="/:enrollerCode?/termsandcondition"
          exact
          element={<TermsAndCondition />}
        />
        <Route
          path="/:enrollerCode?/privacypolicy"
          exact
          element={<PrivacyPolicy />}
        />
        <Route
          path="/:enrollerCode?/spampolicy"
          exact
          element={<SpamPolicy />}
        />
        <Route path="/:enrollerCode?/dmca" exact element={<Dmca />} />
        <Route path="/checkout" element={<Checkout />} />
      </Routes>
      <ToastContainer theme="dark" />
      <TokenRefreshModal />
    </Router>
  );
}

export default App;
